import type {Block, Inline} from '@contentful/rich-text-types'

import {slugify} from './slugify'
import {documentToPlainTextString} from './analytics'

/**
 * Extracts plain text from a Contentful rich text node and returns both the text and its slugified ID.
 * This ensures consistent heading IDs between rendered content and table of contents.
 *
 * @param node - A Contentful rich text node (Block or Inline)
 * @returns Object with the extracted text and slugified ID
 */
export function getHeadingTextAndId(node: Block | Inline): {text: string; id: string} {
  const text = documentToPlainTextString(node, ' ')
  return {
    text,
    id: slugify(text),
  }
}
